import React from "react";
import './Updates.css'
import { Updates_data } from "./Updates_data";

import useMeta from '../../../hooks/useMeta'


import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";
import Footer from "../../../CommonComponent/Footer/footer";

import { data, Link, useParams } from "react-router-dom";

const UpdatesUI = () => {

    const { Update_pg_ID } = useParams();

    const CurrectPG = Updates_data[Update_pg_ID];

    const pg_title = CurrectPG?.title || null;

    const Data = CurrectPG?.data || null;

    function CheckValue(index) {
        return (index % 2 !== 0) ? true : false
    }

    const Meta_title = CurrectPG?.Meta_title || null;
    const OG_title = CurrectPG?.OG_title || null;
    const Meta_Description = CurrectPG?.Meta_Description || null;
    const OG_Description = CurrectPG?.OG_Description || null;
    const Meta_OG_URl = CurrectPG?.Meta_OG_URl || null;

    useMeta({
        title: Meta_title,
        description: Meta_Description,
        canonical: Meta_OG_URl,
        og: {
            locale: 'en_US',
            type: 'article',
            title: OG_title,
            description: OG_Description,
            url: Meta_OG_URl,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="Updates_pg_container">
                <h1 className="Updates_pg_title">{pg_title}</h1>
                <table className="Updates_pg_table">
                    <tbody>
                        {Data.map((item, index) => (
                            <tr key={index}>
                                <td className={CheckValue(index) === true ? (index !== Data.length - 1 ? 'Border-none' : '') : 'even-row'}>
                                    <Link target="__blank" to={item.url || "#"}>
                                        {item.title}
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    );
}

export default UpdatesUI;